import { useEffect, useState } from "react";
import { ChevronDown, Shield, Truck, RotateCcw, Lock, FileText } from "lucide-react";
import { API } from "../lib/api";
import Seo from "../components/Seo";

const POLICIES = [
  [Shield, "Transparent Pricing", "Every product shows its price clearly. Member and Club prices are set by Suvikka and shown before you buy. No hidden fees, no fake discounts."],
  [Truck, "Shipping", "Orders are prepared and dispatched from Suvikka outlets and central stock. Delivery estimates are shown at checkout."],
  [RotateCcw, "Returns & Refunds", "Eligible items can be returned per our returns policy. Wallet rewards linked to a cancelled or returned order may be reversed accordingly."],
  [Lock, "Privacy", "Your personal data is protected. Outlet partners and riders only see the information needed to fulfil your order; only Suvikka admins see full account data."],
  [FileText, "Membership & Wallet Terms", "Club membership benefits are subject to availability and applicable terms. Wallet rewards are promotional credits with no cash value and may carry eligibility conditions."],
];

function FaqItem({ q, a, i }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-stone-200" data-testid={`faq-${i}`}>
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between py-4 text-left" data-testid={`faq-toggle-${i}`}>
        <span className="font-medium text-stone-900">{q}</span>
        <ChevronDown className={`w-5 h-5 text-stone-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <p className="pb-4 text-stone-600 text-sm leading-relaxed">{a}</p>}
    </div>
  );
}

export default function Trust() {
  const [faq, setFaq] = useState([]);
  useEffect(() => { API.get("/faq").then((r) => setFaq(r.data)).catch(() => {}); }, []);
  return (
    <div className="bg-white" data-testid="trust-page">
      <Seo title="Trust Center & FAQ | Suvikka" description="Suvikka Trust Center — transparent pricing, shipping, returns, privacy, membership and wallet terms, plus answers to common questions." canonicalPath="/trust" />
      <section className="bg-[#FAF6F1] border-b border-stone-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14 text-center">
          <h1 className="font-display text-4xl sm:text-5xl font-semibold text-stone-900">Trust Center</h1>
          <p className="text-stone-500 mt-3">Clear, honest answers about how Suvikka works.</p>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 py-14 grid gap-4 sm:grid-cols-2">
        {POLICIES.map(([Icon, t, d], i) => (
          <div key={i} className="border border-stone-200 rounded-2xl p-6" data-testid={`policy-${i}`}>
            <span className="inline-flex p-2.5 rounded-xl bg-[#FFF0F4] text-[#6A1B29]"><Icon className="w-5 h-5" /></span>
            <h3 className="font-display text-lg font-semibold text-stone-900 mt-3">{t}</h3>
            <p className="text-sm text-stone-500 mt-2 leading-relaxed">{d}</p>
          </div>
        ))}
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 pb-20">
        <h2 className="font-display text-2xl sm:text-3xl font-semibold text-stone-900 mb-4">Frequently Asked Questions</h2>
        {faq.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} i={i} />)}
      </section>
    </div>
  );
}
